import { render, staticRenderFns } from "./DmmV3Process.vue?vue&type=template&id=638b15e0&scoped=true"
import script from "./DmmV3Process.vue?vue&type=script&lang=js"
export * from "./DmmV3Process.vue?vue&type=script&lang=js"
import style0 from "./DmmV3Process.vue?vue&type=style&index=0&id=638b15e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b15e0",
  null
  
)

export default component.exports